import { API } from "aws-amplify";

export const createOrder = (body) => {
  return new Promise((resolve, reject) => {
    API.post("user", `/createorder/`, { body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// export const getMyLicense = (email) => {
//   return new Promise((resolve, reject) => {
//     API.get("user", `/getmylicense?email=${email}`)
//       .then((res) => {
//         // console.log("res in get my license =====", res);
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const applyCoupon = (code, productCode) => {
  return API.get("user", `/applycoupon/${code}?product=${productCode}`);
};

export const capturePayment = (body) => {
  return API.post("user", `/capturepayment/`, { body });
};

export const getDomainDeatils = (subdomain) => {
  return API.get("user", `/getdomaindetails?subdomain=${subdomain}`);
};
export const getCouponDetails = (query) => {
  return API.get("inaffiliateUser", `/getCoupon${query}`);
};

// export const createFreeOrder = (body) => {
//   return new Promise((resolve, reject) => {
//     API.post("user", `/createfreelicense/`, { body })
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const getLicense = (body) => {
  return new Promise((resolve, reject) => {
    API.post("user", "/getLicense", { body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createFreeOrder = (body) => {
  return new Promise((resolve, reject) => {
    API.post("user", `/CreateFreeLicense`, { body })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
